;(function (define) {
	'use strict'
	define('es6ish-class/es6ish-class',['require','exports','module','./lib/ES6ishClassError','./lib/create','./lib/extend'],function(require,exports,module){
		var ES6ishClassError 	= require( './lib/ES6ishClassError' ),
			create 				= require( './lib/create' ),
			extend 				= require( './lib/extend' );

		var FN 	= "function",
			OPC = Object.prototype.constructor;

		var ES6ishClassMethods = {

			/**
			 * Set parent as your parent class.  
			 * Mimics the behavior of class NAME extends PARENT.
			 * @param  {function} parent Contructor funciton for your parent class.
			 * @return {function}        Returns your class's constructor.
			 */
			extendsFrom : function( parent ){
				if (typeof parent !== FN) {
					throw new ES6ishClassError( 'parent not a valid constructor.', this, parent );
				}
				var proto = create( parent.prototype );
				
				extend( proto, this.prototype );

				proto.constructor = this;
				this.superclass = parent.prototype;
				this.prototype = proto;
				if (parent.prototype.constructor === OPC) {
					parent.prototype.constructor = parent;
				}
				return this;
			},

			/**
			 * Define methods on your class's prototype.
			 * Can be called multiple times for easier extension.
			 * @param  {object} proto Collection of methods to apply to your class's prototype.
			 * @return {function}     Constructor function for easier chaining.
			 */
			define : function( proto ){
				extend( this.prototype, proto );
				return this;
			},

			/**
			 * Set your class as the parent for another class.
			 * Effective opposite of extendsFrom.
			 * @param  {function} child Would-be constructor for your child class.
			 * @return {function}       child with es6ish-class methods attached.
			 */
			spawn : function( child ){
				es6ishClass( child );
				this.extendsFrom.call( child, this );
				return child;
			}
		};
		/**
		 * Added es6ish-class functionality to your class by mapping 
		 * static methods directly to the constructor.
		 * @param  {function} _constructor Constructor class to enhance.
		 * @return {function}              Contructor function, but now super-awesome.
		 */
		function es6ishClass( _constructor ){
			if (typeof _constructor !== FN) {
				throw new ES6ishClassError( 'Constructor not a valid function.', undefined, _constructor );
				return;
			}
			if( _constructor.extendsFrom !== ES6ishClassMethods.extendsFrom ){
				extend( _constructor, ES6ishClassMethods );
			}
			return _constructor;
		}

		return es6ishClass;
	});
})(typeof module === 'object' && module.exports && typeof define !== 'function'
    ? function (factory) { module.exports = factory(require, exports, module); }
    : define
);
